import * as d3 from 'd3'

export default {
  methods: {

    draw_Table() {

      let head = this.header
      let tbl = this.table

      let table = this.canvasForms
      .append('g')
      .attr('transform', `translate(0, ${this.funcY + .5})`)

      let y_ = this.header.height + (tbl.lineHeight/2) + 1
      this.rawData.forEach((d,i)=> {

        this.columns.forEach((col, c)=> {

          if(col.type == 'prog') {
            this.draw_Progress(table, d, col, col.sx+5, y_, tbl.pro.color)
          } else {
            table
            .append('text')
            .attr('x', col.tx).attr('y', y_ + tbl.tSize*0.36)
            .attr('font-size', tbl.tSize)
            .attr('text-anchor', col.align)
            .attr('fill', () => {
              let color = col.tColor
              if (d[this.schedule.data.code] == 'Overall') color = '#333'
              if (col.type == 'delta') color = this.gmx_deltaValue(d[col.code])
              return color
            })
            .text(d[col.code])
            .call(this.event_Link, col, i)
          }
        })
        if(d[this.schedule.data.code] == 'Overall') {
          this.draw_Line(table, 0, head.width, y_-(tbl.lineHeight/2)-.5, y_-(tbl.lineHeight/2)-.5, '#757575')
        }
        y_ = y_ + tbl.lineHeight
      })
    },
  
    draw_Progress(selection, data, col, x, y, color) {
      let tbl = this.table
      let barY = y - this.table.pro.pulsY
      let pro = data[col.code]
      let barLen = (pro/100) * (col.width-5.5)

      selection
      .append('rect')
      .attr('x', x + .5).attr('y', barY)
      .attr('width', col.width - 5.5)
      .attr('height', 12)
      .attr('fill', '#F4F5F5')
      .attr('opacity', 1)

      selection
      .append('rect')
      .attr('x', x + .5).attr('y', barY)
      .attr('width', barLen)
      .attr('height', 12)
      .attr('fill', color)
      .attr('opacity', 1)

      selection
      .append('text')
      .attr('x', pro > 70 ? col.sx + 5 + barLen - 2 : col.sx + 5 + barLen + 2)
      .attr('y', y + tbl.tSize*0.36)
      .attr('font-size', tbl.tSize)
      .attr('text-anchor', pro > 70 ? 'end' : 'start')
      .attr('fill', col.tColor)
      .text(pro+'%')

    }
  }
}